import { 
  Component, 
  EventEmitter, 
  HostListener, 
  OnInit, 
  Output 
} from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid';
import { Globals } from 'app/globals';
import { CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { isNull } from 'util';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-archived-clients',
  templateUrl: './archived-clients.component.html',
  styleUrls: ['./archived-clients.component.scss']
})
export class ArchivedClientsComponent implements OnInit {
 @Output() showTableChange = new EventEmitter<boolean>();
  
 @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
   console.log(event);
   this.showFilterFields = false;
 }

 public tags = [];
 public showFilterFields: boolean = false;
 public fields: string[] = ['Email', 'FirstName', 'LastName', 'Status'];
 public filters = [
   {
       text: "Contains",
       value: "contains"
   },
   {
       text: "Equals",
       value: "equals"
   },
   {
       text: "Not Equals",
       value: "notEquals"
   },
   {
       text: "Starts With",
       value:"startsWith"
   },
   {
       text: "Ends With",
       value:"endsWith"
   },
   {
       text: "Not Contain",
       value: "notContain"
   },
   {
       text: "Not Start With",
       value: "notStartWith"
   }
 ];
 public canDelete: boolean = false;
 public canAssign: boolean = false;
 public action = "Add";
 public gridOptions: GridOptions;
 public clientsHeaders: any[];
 public assessmentsHeaders: any[] = [];
 public clients: any[] = [];
 public overlayNoRowsTemplate: any;
 public rowSelection: any = 'multiple';
 public fileName: string = "";
 public blobFile: any = null;
 public okImportClientsButton: string = "Ok";
 public returnedClients: string[] = [];
 public showTable: boolean = false;
 public returnModalMessage = '';

 public gridApi: any;
 private userFilters: any[] = [];
 private fromAgGridFilter: boolean = false;
 private rowCount: number;
 private clientsToDelete: number[] = [];
 private clientsToActivate: Array<number> = [];

 constructor(
   private toastr: ToastrService,
   private coachService: CoachService,
   public _Globals: Globals,
   private router: Router
   ) { 
     this.overlayNoRowsTemplate = "<span>No row to show</span>";
   }

 ngOnInit() {
   this.gridOptions = <GridOptions>{};
   this.gridOptions.rowHeight = 45;
   this.gridOptions.headerHeight = 40;
   // this.assessmentsGridOptions = <GridOptions>{};
   // this.assessmentsGridOptions.rowHeight = 45;
   // this.assessmentsGridOptions.headerHeight = 40;

   this.clientsHeaders = this.createHeaders();
   this.assessmentsHeaders = this.createAssessmentsHeaders()

   this.GetArchiveCoachClients();  
  //  this.getCoachAvailableAssessmentsByType(1);
  //  this.getCoachAvailableAssessmentsByType(2);
 }

 public removeTag(index: number) : void {
   let filter = this.tags[index].split(" ");
   console.log(filter);

   //remove the filter
   var filterComponent = this.gridApi.getFilterInstance(filter[0]);
   filterComponent.setModel(null);
   this.gridApi.onFilterChanged();

   //removing the filter from list 
   this.tags.splice(index, 1);
   this.userFilters.splice(index, 1);
   console.log(this.tags);

   let filter2: any;
   let condition2: any;
   let pos = this.userFilters.map(function (e) { return e.field; }).indexOf(filter[0]);
   if (pos != -1) {
       filter2 = this.userFilters[pos].filter;
       condition2 = this.userFilters[pos].condition;
       this.excecuteFilter(filter[0], filter2, condition2);
   } 
   console.log(this.userFilters);
 }

 public applyFilter(field:string, filter:string, condition:string): void {
   //let field = $('#field').val();
   //let filter = $('#filter').val();
   //let condition = $('#condition1').val();

   if (field === "" || filter === "" || condition === "") {
       this.toastr.warning("Empty fields", "ELI");
       return;
   }

   console.log("field", field);
   console.log("filter", filter);
   console.log("value", condition);

   let filter2: any;
   let condition2: any;
   let multipleConditions: boolean = false;
   let pos = this.userFilters.map(function (e) { return e.field; }).indexOf(field);
   if (pos != -1) {
       filter2 = this.userFilters[pos].filter;
       condition2 = this.userFilters[pos].condition;
       multipleConditions = true;
   } 

   let newObj = {
       field: field,
       filter: filter,
       condition: condition
   }

   let contains = this.containsObject(newObj, this.userFilters);
   if (!contains) {
       this.userFilters.push(newObj);
       console.log(this.userFilters);

       let amount = this.getNumberOfConditionsByColumn(this.userFilters, field);
       if (amount <= 2) {
           this.tags.push(field + " " + filter + " " + condition);
           console.log(this.tags);
           this.showFilterFields = false;

           if (multipleConditions) {
               this.applyMultipleFilter(field, filter, condition, filter2, condition2);
           } else {
               if (!this.fromAgGridFilter) {
                   this.excecuteFilter(field, filter, condition);
               }
           }
       } else {
           this.userFilters.pop();
           this.toastr.warning("We are sorry. Conditions are limited to 2 per field.", "ELI");
       }
   } else{
       console.log('already exist');
   }
 }

 public toggleFilter(): void {
   this.showFilterFields = true;
   this.fromAgGridFilter = false;
 }

 public filterChanged(e: any): void {
   this.fromAgGridFilter = true;
   console.log(e.api.filterManager.allFilters);

   let allFilters = e.api.filterManager.allFilters;
   let filterKeys = Object.keys(e.api.filterManager.allFilters);

   filterKeys.forEach((item) => {
       if (!isNull(allFilters[item].filterPromise.resolution.filterText)) {
           console.log(item);
           console.log(allFilters[item].filterPromise.resolution.filter);
           console.log(allFilters[item].filterPromise.resolution.filterText);
           this.applyFilter(item, allFilters[item].filterPromise.resolution.filter, allFilters[item].filterPromise.resolution.filterText);
       }
   })
 }

 public onGridReady(params: any): void {
   this.gridApi = params.api;
   this.sizeToFit(this.gridApi);
   setTimeout(() => {
       $(".ag-floating-filter-input").attr("placeholder", "Filter");
   }, 100);
 }

 public onSelectionChangedChoiceSet(event: any): void {
   console.log("onSelectionChanged ", event);
   this.rowCount = event.api.getSelectedNodes().length;
   console.log("selection changed, ", this.rowCount + " rows selected");

   if (this.rowCount >= 1) {
       this.canDelete = true;
       this.canAssign = true;
   } else {
       this.canDelete = false;
       this.canAssign = false;
   }
 }

 public activateClients(): void {
   this.coachService.postActivateCoachClients(this.clientsToActivate)
       .subscribe((data: any) => {
           console.log('response_ArchiveCoachClients', data);
           if (this._Globals.validationToken(data.result.Result)) {

               let _data = JSON.parse(data.result.Data);
               console.log('_data', _data);

               this.clientsToActivate = [];

               if (data.result.Result === 1) {
                   this.toastr.success('Clients activated successfully.', 'ELI');
                   this.GetArchiveCoachClients();
                   $('#activateClientsModal').modal('hide');
                   this.deselectAllCheckBox(this.gridApi);
               } else {
                   //display a modal
                   this.returnedClients = _data;
                   console.log('returnedClients', this.returnedClients);
                   this.openReturnedModal('The following clients could not be activated');
               }
               
           } 
   });
 }

 public openConfirmationModal(): void {
   let clientsToDelete = this.getSelectedRows(this.gridApi);
   if (clientsToDelete.length != 0) {
       $("#archivedClientConfirmationDeleteModal").modal({ backdrop: "static" });
       $('#archivedClientConfirmationDeleteModal').modal('show');
   }
 }

 public openActivateModal(): void {
   const selectedRows = this.getSelectedRows(this.gridApi);
   if (selectedRows.length != 0) {
       $("#activateClientsModal").modal({ backdrop: "static" });
       $('#activateClientsModal').modal('show');
   }
 }

 public onRowClicked(e: any): void {
   console.log(e);
   if (e.event.target !== undefined) {
       let data = e.data;
       this.router.navigate(['/app/edit_clients', data['ClientId'], data["Email"], data["FirstName"], data["LastName"], data["Status"]]);
   }
 }

 public filterModified(e: any) {
   console.log(e.api.filterManager.allFilters);
 }

 public preventSpace(value: string, event: any, id: string): any {
   if (value == null || value == "") {
       if (event.keyCode == 32) {
           return false;
       }
   }
   if (value == " ") {
       $('#' + id + '').val('');
   }
 }

 public closeModalReturned(): void {
   $('#archiveReturnedModal').modal('hide');
   this.closeModalConfirmation();
   this.clientsToDelete = [];
   this.deselectAllCheckBox(this.gridApi);
 }

 public deleteArchived(): void {
   const clientsToDelete = this.getSelectedRows(this.gridApi);
   console.log(clientsToDelete);

   clientsToDelete.forEach((client: any) => {
       this.clientsToDelete.push(client.ClientId);
   });

   this.deleteArchivedClients();
 }

 public activate(): void {
   this.clientsToActivate = this.getSelectedRows(this.gridApi).map((client: any) => client.ClientId);
   
   this.activateClients();
 }

 private excecuteFilter(field: any, filter: any, condition: any): void {
   var filterComponent = this.gridApi.getFilterInstance(field);
   filterComponent.setModel({
       type: filter,
       filter: condition
   });
   this.gridApi.onFilterChanged();
 }

 private applyMultipleFilter(field: any, filter: any, condition1: any, filter2: any, condition2: any): void {

   console.log("field", field);
   console.log("filter", filter);
   console.log("value", condition1);
   let operator = "AND";
   console.log("filter2", filter2);
   console.log("value2", condition2);

   var sportsFilterComponent = this.gridApi.getFilterInstance(field);
   sportsFilterComponent.setModel({
       condition1: {
           type: filter,
           filter: condition1
       },
       condition2: {
           type: filter2,
           filter: condition2
       },            
       operator: operator
   });
   this.gridApi.onFilterChanged();

   //this.tags.push(field + " " + filter + " " + condition1 + " " + operator + " " + filter2 + " " + condition2);
   console.log(this.tags);
   this.showFilterFields = false;
 }

 private containsObject(obj: any, list: any): boolean {
   let i: number;
   for (i = 0; i < list.length; i++) {
       if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
           return true;
       }
   }
   return false;
 }

 private getNumberOfConditionsByColumn(array: any[], field: any): number {
   let total = 0;
   for (let i = 0; i < array.length; i++) {
       if (array[i].field === field) {
           total++;
       }
   }
   return total;
 }

 private sizeToFit(gridApi: any): void {
   gridApi.sizeColumnsToFit();
   $('.ag-body-viewport').css('overflow', 'overlay');
 }

 public getSelectedRows(gridApi): any {
   console.log("SELECTED", this.gridApi.getSelectedRows());
   return gridApi.getSelectedRows();
 }

 public deselectAllCheckBox(gridApi: any): void {
   this.canDelete = false;
   this.canAssign = false;
   gridApi.forEachNode(function (node) {
       node.setSelected(false);
   });
 }

 public GetArchiveCoachClients(): void {
   this.coachService.getArchivedCoachClients().subscribe((data: any) => {
       console.log('response_GetArchiveCoachClients', data);
       if (this._Globals.validationToken(data.result.Result)) {
           let _data = JSON.parse(data.result.Data);
           console.log('_data', _data);

           this.clients = [];
           setTimeout(() => {
              this.clients = _data;
              this.showTable = true;
              this.showTableChange.emit(true);
           }, 500);
       } 
   });
 }

 createHeaders() {
   let columnDefs = new Array();

   let emailHeader = {
       headerName: 'Email',
       field: 'Email',
       headerCheckboxSelection: true,
       headerCheckboxSelectionFilteredOnly: true,
       checkboxSelection: true,
       filterParams: {
           apply: true
       },
       minWidth: 200,
       width: 200,
       suppressSizeToFit: false,
       cellRenderer: function (params) {
           return params.value;
       }
   };
   columnDefs.push(emailHeader);

   let nameHeader = {
       headerName: 'First Name',
       field: 'FirstName',
       filterParams: {
           suppressAndOrCondition: true,
           apply: true
       },
       minWidth: 200,
       width: 200,
       suppressSizeToFit: false,
       cellRenderer: function (params) {
           return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
       }
   };
   columnDefs.push(nameHeader);

   let lastNameHeader = {
       headerName: 'Last Name',
       field: 'LastName',
       filterParams: {
           apply: true
       },
       minWidth: 200,
       width: 200,
       suppressSizeToFit: false,
       cellRenderer: function (params) {
           return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
       }
   };
   columnDefs.push(lastNameHeader);

   let statusHeader = {
       headerName: 'Status',
       field: 'Status',
       filterParams: {
           apply: true
       },
       minWidth: 200,
       width: 200,
       suppressSizeToFit: false,
       cellRenderer: function (params) {
           return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
       }
   };
   columnDefs.push(statusHeader);

  //  let assessmentStatusHeader = {
  //      headerName: 'Assessment Status',
  //      field: 'AssessmentStatus',
  //      filterParams: {
  //          apply: true
  //      },
  //      minWidth: 200,
  //      width: 200,
  //      suppressSizeToFit: false,
  //      cellRenderer: function (params) {
  //          return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
  //      }
  //  };
  //  columnDefs.push(assessmentStatusHeader);

   return columnDefs;
 }

 private createAssessmentsHeaders(): any[] {
   let columnDefs = new Array();

   let nameHeader = {
       headerName: 'Name',
       field: 'AssessmentName',
       minWidth: 200,
       width: 200,
       suppressSizeToFit: false,
       cellRenderer: function (params) {
           return params.value;
       }
   };
   columnDefs.push(nameHeader);

   let quantityHeader = {
       headerName: 'Quantity',
       field: 'Amount',
       minWidth: 120,
       width: 120,
       suppressSizeToFit: true,
       cellRenderer: function (params) {
           return params.value;
       }
   };
   columnDefs.push(quantityHeader);

   return columnDefs;
 }

//  private getCoachAvailableAssessmentsByType(assessmentType: number): void {
//    this.coachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
//        console.log('response_GetRaters', data);
//        if (this._Globals.validationToken(data.result.Result)) {
//            let _data = JSON.parse(data.result.Data);
//            console.log('_data', _data);

//            if (assessmentType === 1) {
//                this.assessmentsELIData = _data;
//            } else {
//                this.assessments360Data = _data;
//            }

//        }

//    });
//  } 

 private closeModalConfirmation(): void {
   $('#archivedClientConfirmationDeleteModal').modal('hide');
 }

 private deleteArchivedClients(): void {
   this.coachService.postDeleteClients(this.clientsToDelete).subscribe((data: any) => {
       console.log('response_deleteClients', data);
       if (this._Globals.validationToken(data.result.Result)) {

           let _data = JSON.parse(data.result.Data);
           console.log('_data', _data);

           this.clientsToDelete = [];

           if (data.result.Result === 1) {
               this.toastr.success('Clients deleted successfully.', 'ELI');
               this.GetArchiveCoachClients();
               this.closeModalConfirmation();
               this.deselectAllCheckBox(this.gridApi);
           } else {
               //display a modal
               this.returnedClients = _data;
               console.log('returnedClients', this.returnedClients);
               this.closeModalConfirmation();
               this.openReturnedModal(
                   'The following clients could not be removed because either ' + 
                   'they have pending assessments or they are assigned as raters for other clients'
                   );
           }
           
       } 
   });
 }

 private openReturnedModal(message: string): void {
   $("#archiveReturnedModal").modal({ backdrop: "static" });
   $('#archiveReturnedModal').modal('show');
   this.returnModalMessage = message;
 }

}
